import React from 'react';

import Spinner from '../../Spinner/Spinner';
import { Wishlist } from '../../MyLom/Account/Wishlist/Types';
import { readPublicWishlist } from '../../Api/Wishlist';
import WishlistPublicItem from '../Components/WishlistPublicItem';

import '../../MyLom/Account/ProfileTabs/ProfileTabs.scss';
import '../../MyLom/Account/Wishlist/Wishlist.scss';

interface Props {
    shortUri: string;
}

const WishlistPublicContainer: React.FunctionComponent<Props> = (props) => {
    const [wishlist, updateWishlist] = React.useState<Wishlist | null>(null);

    const fetchWishlist = React.useCallback(
        () =>
            readPublicWishlist(
                props.shortUri,
                (newWishlist) => updateWishlist(newWishlist),
                () => {},
            ),
        [],
    );

    React.useEffect(() => fetchWishlist(), [fetchWishlist]);

    if (!wishlist) {
        return (
            <div className="consultant-assignment">
                <Spinner highPerformance={false} />
            </div>
        );
    }

    return (
        <>
            <div className="product-wishlist product-wishlist--public">
                {wishlist.items.length > 0 && <header className="product-wishlist__header" />}
                {wishlist.items.map((item) => (
                    <WishlistPublicItem item={item} key={item.articleNumber} />
                ))}
                {wishlist.items.length === 0 && <p>Es befinden sich keine Produkte in dieser Wunschliste</p>}
            </div>
        </>
    );
};

export default WishlistPublicContainer;
